module.exports = __webpack_public_path__ + "img/zdysy.ec373bdd.svg";